"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.ChartsContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 12px;\n  box-sizing: border-box;\n  display: flex;\n  flex-grow: 1;\n"], ["\n  margin-top: 12px;\n  box-sizing: border-box;\n  display: flex;\n  flex-grow: 1;\n"])));
exports.ChartsContainer.displayName = 'ChartsContainer';
exports.YAxisTitle = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n"], ["\n  color: ",
    ";\n  font-size: 14px;\n"])), function (_a) {
    var charts = _a.theme.colours.charts;
    return charts.label;
});
exports.YAxisTitle.displayName = 'YAxisTitle';
exports.YAxisLabel = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 20px;\n  margin-left: -8px;\n  color: ", ";\n  text-align: left;\n"], ["\n  width: 20px;\n  margin-left: -8px;\n  color: ",
    ";\n  text-align: left;\n"])), function (_a) {
    var charts = _a.theme.colours.charts;
    return charts.label;
});
exports.YAxisLabel.displayName = 'YAxisLabel';
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=charts.styled.js.map